import * as yup from 'yup'
import { defineMessages, IntlShape } from 'react-intl'

import { IRegisterBookingTaxInvoicedValues } from 'features/Bookings/types'

const taxFolioMessages = defineMessages({
  min: {
    id: 'bookings.registerBookingTaxInvoiced.taxFolio.min',
    defaultMessage: 'The folio must be at least {min} characters long'
  },
  max: {
    id: 'bookings.registerBookingTaxInvoiced.taxFolio.max',
    defaultMessage: 'The folio must be at most {max} characters long'
  },
  required: {
    id: 'bookings.registerBookingTaxInvoiced.taxFolio.required',
    defaultMessage: 'The folio is required'
  }
})

export const schema = (intl: IntlShape): yup.SchemaOf<IRegisterBookingTaxInvoicedValues> => {
  return yup.object().shape({
    taxFolio: yup
      .string()
      .min(3, ({ min }) => intl.formatMessage(taxFolioMessages.min, { min }))
      .max(50, ({ max }) => intl.formatMessage(taxFolioMessages.max, { max }))
      .required(intl.formatMessage(taxFolioMessages.required))
  })
}
